import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import ButtonBase from "@mui/material/ButtonBase";
import Link from "arena/components/Link";
import { Helmet } from "react-helmet-async";
import { getLogoSrcSet } from "core/utils/getSrcSet";

const MAX_WIDTH_DESKTOP = 200;
const MAX_WIDTH_MOBILE = 140;
const MAX_HEIGHT_MOBILE = 30;
const MAX_HEIGHT_DESKTOP = 40;

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flexShrink: 1,
  minWidth: 0,
  width: "auto",
  maxWidth: MAX_WIDTH_MOBILE,
  height: MAX_HEIGHT_MOBILE,
  [theme.breakpoints.up("sm")]: {
    height: MAX_HEIGHT_DESKTOP,
    maxWidth: MAX_WIDTH_DESKTOP,
  },
}));

const DEFAULT = "DEFAULT";
const HIGH = "HIGH";
const MAXRES = "MAXRES";
const MEDIUM = "MEDIUM";

const StyledImage = styled("img")(({ theme }) => ({
  display: "block",
  height: MAX_HEIGHT_MOBILE,
  width: "auto",
  maxWidth: MAX_WIDTH_MOBILE,
  objectFit: "contain",
  objectPosition: "left center",
  margin: 0,
  border: 0,
  borderRadius: 0,
  flexShrink: 1,
  [theme.breakpoints.up("sm")]: {
    height: MAX_HEIGHT_DESKTOP,
    maxWidth: MAX_WIDTH_DESKTOP,
    flexShrink: 0,
  },
}));

export default function HeaderLogo({ arena }) {
  const onClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {arena.logo && (
        <Helmet>
          <link rel="preload" href={arena.logo.url} as="image" />
        </Helmet>
      )}
      <Tooltip title={arena.title}>
        <StyledButtonBase component={Link} to="/" onClick={onClick}>
          {arena.logo ? (
            <StyledImage
              src={arena.logo.url}
              srcSet={getLogoSrcSet(arena.logo.thumbnails)}
              alt={arena.title}
            />
          ) : (
            arena.title
          )}
        </StyledButtonBase>
      </Tooltip>
    </>
  );
}

HeaderLogo.propTypes = {
  arena: PropTypes.shape({
    title: PropTypes.string.isRequired,
    logo: PropTypes.shape({
      url: PropTypes.string,
      thumbnails: PropTypes.arrayOf(
        PropTypes.shape({
          format: PropTypes.oneOf([DEFAULT, MEDIUM, HIGH, MAXRES]).isRequired,
          url: PropTypes.string.isRequired,
          webpUrl: PropTypes.string,
        })
      ),
    }),
  }),
};
